import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { OptimizationBilling } from '@/features/optimization/billing'

const date = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined)
export const Route = createFileRoute('/_authenticated/optimization/billing')({
  validateSearch: z.object({
    source_id: z.coerce.number().int().positive().optional().catch(undefined),
    start: date,
    end: date,
    instance_id: z.coerce.number().int().positive().optional().catch(undefined),
  }),
  component: OptimizationBilling,
})
